import React, { Component, Fragment } from 'react'
import {renderDeviceIcon} from "../../../Templates/functions"
class DevicesWidgetItem extends Component {

    renderStatus = (status) => {
        let color
        switch(status) {
            case "online":
                color = '#228b22'
                break
            case "idle":
                color = 'orange'
                break
            case "offline":
                color = '#cdcdcd'
                break
            default:
                color = '#cdcdcd'
            }
        return <svg className="status-icon-circle" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '.25em', marginBottom: '.1em' }}>
                    <ellipse cx="8" cy="8" rx="8" ry="8" fill={color} />
                </svg>
    }

    render() {
        return (
            <Fragment>
                <div id="device-icon-image-container">
                    {renderDeviceIcon(this.props.type)}
                </div>
                <p id="device-name">{this.props.nickname || this.props.name}</p>
                <div id="activity-status" className="flex-apart">
                    <p>{this.props.status}</p>
                    {this.renderStatus(this.props.status ? this.props.status.toLowerCase() : "")}
                </div>
            </Fragment>
        )
    }
}

export default DevicesWidgetItem
